// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stack from "./Stack.res.js";
import * as Title from "../typography/Title.res.js";
import * as React from "react";
import * as Inline from "./Inline.res.js";
import Wino_logoPng from "./wino_logo.png";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let imageUri = Wino_logoPng;
function PublicPage(props) {
  let description = props.description;
  let title = props.title;
  let newrecord = {
    ...{
      className: "backgroundColor-xhb2u9n alignItems-x6s0dn4 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/PublicPage.res.js:12"
    }
  };
  let newrecord$1 = {
    ...{
      className: "maxWidth-x18d02x8 paddingBottom-xo0ha1f paddingInline-xj7an9n paddingTop-x1p5oq8j",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/PublicPage.res.js:24"
    }
  };
  let newrecord$2 = {
    ...{
      className: "alignSelf-xamitd3 height-x1vqgdyp width-x100vrsf",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/PublicPage.res.js:19"
    }
  };
  newrecord$1.children = [JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(Stack.make, {
      children: JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsx("img", (newrecord$2.src = imageUri, newrecord$2)), JsxRuntime.jsx(Title.make, {
            children: title !== undefined ? title : null,
            level: 1
          })],
          space: "medium",
          alignY: "center"
        }),
        align: "spaceBetween"
      })
    }), JsxRuntime.jsx(Stack.make, {
      children: description !== undefined ? description : null,
      space: "xsmall"
    })],
    space: "medium"
  }), props.children];
  newrecord.children = JsxRuntime.jsxs("div", newrecord$1);
  return JsxRuntime.jsx("div", newrecord);
}
let make = React.memo(PublicPage);
export { make };
/* styles Not a pure module */